import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=2f63bc1d&scoped=true&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63bc1d",
  null
  
)

export default component.exports